type McpOnlyUser = {
  isSuperuser?: boolean
  accounts?: { alias?: string, plan?: string }[] | null
} | null | undefined

// Read from the user's account list, not the account meta, which loads later and trails the route on deep links and
// account switches. Aliases compare case-insensitively, as the server does.
export function isMcpOnlyAccount(user: McpOnlyUser, accountAlias: string | null | undefined): boolean {
  if (user?.isSuperuser || !accountAlias) { return false }
  const alias = accountAlias.toLowerCase()
  return (user?.accounts ?? []).find(account => account.alias?.toLowerCase() === alias)?.plan === "mcp"
}
